export class DialogController {
    $mdDialog;
    activeElement;
    theme;
    static $inject = ['$scope', '$mdDialog', 'ThemeService'];
    constructor($scope, $mdDialog, themeService, activeElement) {
        this.$mdDialog = $mdDialog;
        this.activeElement = activeElement !== undefined ? activeElement : document.activeElement;
        this.theme = themeService.theme;
        themeService.evtThemeChange.attach((newTheme) => $scope.$apply(() => this.theme = newTheme));
    }
    cancel() {
        this.$mdDialog.cancel();
        this.restoreFocus();
    }
    hide(data) {
        this.$mdDialog.hide(data);
        this.restoreFocus();
    }
    restoreFocus() {
        if (this.activeElement !== null) {
            this.activeElement.focus();
        }
    }
}
